var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-column vh"},[_c('Navbar'),_c('router-view',{staticStyle:{"flex":"1"}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }